/*
  Gold Mine Orders — homepage scroll reveal (Sprint 4B).
  Progressive enhancement only:
    - Content is visible by default (CSS hidden-state is gated behind the
      `gm-reveal-ready` class this script adds to <html>).
    - If JS is disabled, or IntersectionObserver is missing, or the user
      prefers reduced motion, every element stays visible. Nothing is hidden.
  Presentational only. No commerce, customer, or gating logic.
*/
(function () {
  var docEl = document.documentElement;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Bail out → everything stays visible (default CSS state).
  if (prefersReduced || !('IntersectionObserver' in window)) {
    return;
  }

  function init() {
    var nodes = document.querySelectorAll('.gm-reveal');
    if (!nodes.length) return;

    // Flag the document so the CSS hidden start-state activates.
    docEl.classList.add('gm-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
